export default __webpack_public_path__ + "static/media/empty-ea-list.2e5547be.png";